import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 15px;
  margin: 60px auto;
  text-align: center;
  color: ${({ theme }) => theme.textDark};
  max-width: 420px;

  svg {
    display: block;
    margin: 0 auto 15px;
  }

  h1 {
    font-size: 60px;
  }

  h2 {
    font-size: 30px;
  }

  h2,
  a {
    color: ${({ theme }) => theme.primary};
  }

  p {
    margin: 15px 0;
  }

  a:hover {
    text-decoration: underline;
  }
`;

export default Container;
